import { Button, FormInstance, Row } from "antd";
import { useCallback } from "react";
import { usePermissions } from "../../../../lib/hooks/usePermissions";
import { ITaskUpdateRequest } from "../../types";

type FooterProps = {
  form: FormInstance;
  isClosed: boolean;
  isSaving: boolean;
  openCloseModal: () => void;
  showSideBar: (val: boolean) => void;
  assign: (req: ITaskUpdateRequest) => Promise<1 | 0>;
};

export const Footer = ({
  form,
  isClosed,
  isSaving,
  openCloseModal,
  showSideBar,
  assign,
}: FooterProps) => {
  const { hasAccessByController } = usePermissions("WorkTasks");

  const onClose = useCallback(() => showSideBar(false), [showSideBar]);

  const onAssignClicked = useCallback(async () => {
    try {
      const assignedToUserId = form.getFieldValue("assignedToUserId");

      await assign({ assignToUserId: assignedToUserId || null });

      onClose();
    } catch {}
  }, [assign, onClose, form]);

  return (
    <Row className="divider pa-6">
      {!isClosed ? (
        <>
          {hasAccessByController("Modify") && (
            <Button
              shape="round"
              className="mr-4"
              loading={isSaving}
              disabled={isSaving}
              onClick={onAssignClicked}
            >
              Save
            </Button>
          )}
          {hasAccessByController("Close") && (
            <Button
              shape="round"
              onClick={openCloseModal}
              loading={isSaving}
              disabled={isSaving}
            >
              Close Task
            </Button>
          )}
        </>
      ) : (
        <Button shape="round" onClick={onClose}>
          Close
        </Button>
      )}
    </Row>
  );
};
